import { render } from "./ModuleComplianceUnit.vue?vue&type=template&id=be3c8724&scoped=true"
import script from "./ModuleComplianceUnit.vue?vue&type=script&lang=js"
export * from "./ModuleComplianceUnit.vue?vue&type=script&lang=js"

import "./ModuleComplianceUnit.vue?vue&type=style&index=0&id=be3c8724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be3c8724"]])

export default __exports__